// extracted by mini-css-extract-plugin
export default {"container":"fit-text_container__2JTk0","fit":"fit-text_fit__35mQt","content":"fit-text_content__1SMSE"};